import RouterHolder from "@/components/core/RouterHolder";

export default {
  path: "help",
  component: RouterHolder,
  children: [
    {
      path: "/front/help",
      redirect: "/front/help/list",
    },
    {
      path: "list",
      component: () =>
        import(
          /* webpackChunkName: "front" */ "@/mods/front/helpPage/HelpList"
        ),
    },
  ],
};
